import { useState } from 'react';
import { Button } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useTranslation } from 'react-i18next';
import { ReportType } from '@/api/enum/reportType.enum';
import DownloadReportDialog from './DownloadReportDialog';
import { ReportListItem } from '../ReportListSummaryPage';

// 用戶練習數據 report, scoped to a single exercise series.
// series comes from the page; start/end (時段) are chosen in the dialog.
const userPracticeReport: ReportListItem = {
	id: ReportType.UserPracticeData,
	nameKey: 'reportList.userPracticeData',
	filters: ['start', 'end', 'series'],
	dateScope: 'period',
};

interface Props {
	seriesId?: string;
	seriesTitle?: string;
}

export default function SeriesReportDownloadButton({
	seriesId,
	seriesTitle,
}: Props) {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);

	return (
		<>
			<Button
				endIcon={<FileDownloadOutlinedIcon />}
				onClick={() => setOpen(true)}
				disabled={!seriesId}
				sx={{ marginRight: '24px' }}
				variant='contained'
			>
				{t('reportList.downloadUserPracticeReport')}
			</Button>
			<DownloadReportDialog
				report={userPracticeReport}
				open={open}
				onClose={() => setOpen(false)}
				fixedSeries={
					seriesId ? { id: seriesId, title: seriesTitle } : undefined
				}
			/>
		</>
	);
}
